<template>
    <el-image
      v-if="shopimg"
      class="img-box"
      :src="shopimg"
      fit="cover"
    />
</template>

<script>

export default {
  name: 'shopname',

  components:{},

  props: {
    platform: {
      required: true,
    }
  },

  data () {
    return {
    }
  },

  methods: {
  },

  computed: {
    shopimg() {
      let img
      try {
        img = require(`@/assets/img/platform/pla_${this.platform}.png`)
      } catch (error) {
        img = ""
      }
      return img
    }
  },

  created() {},

  mounted() {

  },
}
</script>


<style lang='scss'>
.img-box img {
  width: 20px;
  height: 20px;
  vertical-align: middle;
}
</style>
